import { useExperimentValue } from '@seek/candidate-feature-flag';

import {
  APPLICANT_INSIGHTS_NUMBER_OF_APPLICANTS_FEATURE_FLAG,
  BEHAVIOURAL_CUES_FILTERS_FEATURE_FLAG,
  BehaviouralCuesFilters,
  type ApplicantInsightNumberOfApplicantsExperiment,
  type BehaviouralCuesFiltersExperiment,
} from 'src/hooks/experiments/constants';

export const useApplicantCountFeatureFlag = () =>
  useExperimentValue<ApplicantInsightNumberOfApplicantsExperiment>(
    APPLICANT_INSIGHTS_NUMBER_OF_APPLICANTS_FEATURE_FLAG,
  );

export const useEnableApplicantCount = () => {
  const flagValue = useApplicantCountFeatureFlag();
  return flagValue === 'count' || flagValue === 'volume';
};

export const useBehaviouralCuesFiltersFeatureFlag = () => {
  const value = useExperimentValue<BehaviouralCuesFiltersExperiment>(
    BEHAVIOURAL_CUES_FILTERS_FEATURE_FLAG,
  );

  return value === BehaviouralCuesFilters;
};
